import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Menu, Transition } from "@headlessui/react";
import { LANG_SWITCHER } from "../../intl/copyright";
import { setLang } from "../../redux/appReducer";
import { Fragment } from "react";

import ukFlag from "../../assets/images/flags/gb.webp";
import ptFlag from "../../assets/images/flags/pt.webp";
import esFlag from "../../assets/images/flags/es.webp";

const flags = {
  pt: ptFlag,
  en: ukFlag,
  es: esFlag,
};

const options = [
  { id: "pt", icon: ptFlag },
  { id: "en", icon: ukFlag },
  { id: "es", icon: esFlag },
];

const LangSwitcher = () => {
  const { lang } = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();

  const copy = LANG_SWITCHER[lang];

  const handleLangSwitch = (lang) => () => {
    dispatch(setLang(lang));
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className="inline-flex w-full">
          <img src={flags[lang]} alt="" width="24px" height="24px"></img>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        leaveFrom="transform opacity-100 scale-100"
        enterTo="transform opacity-100 scale-100"
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        leave="transition ease-in duration-75"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="-translate-y-[calc(100%+50px)] absolute right-0 mt-2 w-[210px] origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {options.map((option, idx) => (
            <div
              className="hover:bg-neutral-100 hover:rounded-md"
              key={`lang-${idx}`}
            >
              <Menu.Item
                className="px-5 py-2 text-neutral-900 flex cursor-pointer"
                key={option.id}
                as={Fragment}
                onClick={handleLangSwitch(option.id)}
              >
                <div>
                  <img
                    src={option.icon}
                    className="h-[25px] w-[25px] mr-5"
                  ></img>
                  <div className="flex justify-between items-center">
                    {copy[option.id]}
                  </div>
                </div>
              </Menu.Item>
            </div>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default LangSwitcher;
